<template>
    <div class="lms__superadmin_users_bulk_add_roles">
        <div class="lms__superadmin_users_bulk_add_roles_main">
            <component-text>Please select the role(s) that will be assigned to those users without a defined role in the csv.</component-text>
            <template v-if="availableRoles.length">
                <form-checkbox
                    v-for="(role, index) in availableRoles"
                    :key="index"
                    :label="role.label"
                    :disabled="hasBlockedRoles"
                    :name="`lms-superadmin-users-bulk-add-roles-${role.value}`"
                    :class="'is-margin-bottom-4'"
                    :value="selectedRoles.includes(role.value)"
                    @input="setUsersRole(role.value, ...arguments)"
                />
            </template>
            <template v-else>
                <component-loading></component-loading>
            </template>
            <component-wrapper>
                <div class="columns">
                    <div class="column"></div>
                    <div class="column is-narrow">
                        <component-button
                            :name="'lms-superadmin-users-bulk-add-roles-previous-step'"
                            :theme="'default'"
                            :to="{ name: 'lms-superadmin-user-bulk-add-upload' }"
                        >Previous step
                        </component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            :disabled="!hasSelectedRoles || !hasUploadedFile || (loggedInUserProfilesWithMAorUARoles.length > 1 && !hasSelectedWorkspace)"
                            :name="'lms-superadmin-users-bulk-add-roles-next-step'"
                            :theme="'primary'"
                            :to="{ name: 'lms-superadmin-user-bulk-add-preview' }"
                        >Next step
                        </component-button>
                    </div>
                </div>
            </component-wrapper>
        </div>
    </div>
</template>

<script>
import ComponentText from '@/components/default/shared/ComponentText'
import FormCheckbox from '@/components/default/forms/FormCheckbox'
import ComponentWrapper from '@/components/default/shared/ComponentWrapper'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentLoading from '@/components/default/shared/ComponentLoading'
import { watchContentChangeEmit } from '@/helpers/mixins'

export default {
  name: 'lms-superadmin-users-bulk-add-roles',
  components: { ComponentLoading, ComponentButton, ComponentWrapper, FormCheckbox, ComponentText },
  mixins: [watchContentChangeEmit],
  computed: {
    loggedInUserProfilesWithMAorUARoles () {
      return this.$store.getters.getLmsSuperadminUserProfilesWithUAOrMARole
    },
    availableRoles () {
      return this.$store.getters.getLmsSuperadminCustomerRoles
    },
    selectedRoles () {
      return this.$store.getters.getLmsSuperadminUsersBulkRoles
    },
    selectedCustomer () {
      return this.$store.getters.getLmsSuperadminUsersBulkCustomerId
    },
    hasSelectedWorkspace () {
      return this.$store.getters.getLmsSuperadminUsersBulkWorkspaceId
    },
    hasBlockedRoles () {
      return this.$store.getters.getLmsSuperadminUsersBulkCustomBlockRoles
    },
    hasSelectedRoles () {
      return Boolean(this.selectedRoles.length)
    },
    hasUploadedFile () {
      return Boolean(this.$store.getters.getLmsSuperadminUsersBulkFile)
    },
    watchContent () {
      return this.selectedRoles
    }
  },
  methods: {
    setUsersRole (name, value) {
      this.$store.dispatch('lmsSuperadminUsersBulkSetRoles', { name, value })
    },
    getRoles () {
      this.$store.dispatch('lmsSuperadminCustomerRolesGet', this.selectedCustomer)
    }
  },
  mounted () {
    if (!this.availableRoles.length && this.selectedCustomer) {
      this.getRoles()
    }
  }
}
</script>
